import { GameSizeConfig } from '../GameItem';

import { GridOptions } from './styled';

export const MAX_SCROLL_BOTTOM_OFFSET = 500;

export const BOTTOM_OFFSET = 700;

export type PerChunk = {
  desktopL: number;
  desktop: number;
  tablet: number;
  mobile: number;
  mobileS: number;
};

export const defaultPerChunk: PerChunk = {
  desktopL: 10,
  desktop: 10,
  tablet: 8,
  mobile: 6,
  mobileS: 6,
};

export const defaultGridOptions: GridOptions = {
  columns: 5,
  columnsTablet: 4,
  columnsMobile: 3,
  columnsMobileS: 2,
  columnGap: 16,
  rowGap: 32,
};

export interface GridDimensions {
  perChunkObj?: PerChunk;
  gridOptions?: GridOptions;
  gameSizesConfig?: GameSizeConfig;
}
